<template>
  <section
    id="Confetti"
    ref="container"
  >
    <h3>250 MILLION</h3>
    <p>people use Truecaller to keep their communication safe and efficient.</p>
    <canvas
      ref="canvas"
      id="ConfettiCanvas"
    />
  </section>
</template>

<script>
import ScrollMagic from "scrollmagic";
import confetti from "canvas-confetti";
import { ref, onMounted } from "vue";

export default {
  setup() {
    const canvas = ref(null);
    const container = ref(null);
    onMounted(() => {
      const controller = new ScrollMagic.Controller();
      new ScrollMagic.Scene({ triggerElement: "#Confetti", duration: "100%" })
        .setClassToggle("#Confetti", "active")
        .addTo(controller);

      const canvasConfetti = confetti.create(canvas.value, {
        resize: true,
        useWorker: true,
      });

      setInterval(() => {
        if (container.value.classList.contains("active") && !document.hidden) {
          canvasConfetti({
            particleCount: 50,
            spread: 180,
            ticks: 100,
            scalar: 1.3,
            colors: ["#d2207d", "#49498b", "#58b57a", "#fcec25", "#32a0ce"],
            origin: {
              y: Math.random(),
              x: Math.random(),
            },
          });
        }
      }, 800);
    });
    return { container, canvas };
  },
};
</script>

<style>
#Confetti {
  position: relative;
  background-color: var(--light-blue);
  background-image: url("../assets/images/illustration-2.png"),
    url("../assets/images/illustration-1.png"),
    url("../assets/images/bg-pattern.png");
  background-repeat: no-repeat, no-repeat;
  background-position: bottom 48px left 0, right 0 top 48px, center center;
  background-size: auto 30%, auto 30%, cover;
  padding: 48px 20px;
  color: var(--blue);
}

#ConfettiCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

#Confetti h3 {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 30px;
  line-height: 37px;
  letter-spacing: -1.03px;
}

#Confetti p {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: -1.03px;
  max-width: 720px;
}

@media screen and (min-width: 720px) {
  #Confetti h3 {
    font-size: 130px;
    line-height: 159px;
    letter-spacing: -4.48px;
  }

  #Confetti p {
    font-size: 24px;
    line-height: 26px;
    letter-spacing: 0;
  }
}
</style>